// convention for constants is
// [App_Name]_[Action]
var OntologyConstants: IOntologyConstants = {
    ONTOLOGY_BEGIN_EDIT: 'ONTOLOGY_BEGIN_EDIT',
    ONTOLOGY_FINISH_EDIT: 'ONTOLOGY_FINISH_EDIT',
    ONTOLOGY_SET_DIRTY: 'ONTOLOGY_SET_DIRTY',
    ONTOLOGY_SELECT: 'ONTOLOGY_SELECT',
    ONTOLOGY_PART_ADD: 'ONTOLOGY_PART_ADD',
    ONTOLOGY_PART_EDIT: 'ONTOLOGY_PART_EDIT',
    ONTOLOGY_PART_DELETE: 'ONTOLOGY_PART_DELETE',
    ONTOLOGY_GRAPHIC_SOURCE_DELETE: 'ONTOLOGY_GRAPHIC_SOURCE_DELETE',
} as const;

export default OntologyConstants;
